export default __webpack_public_path__ + "static/media/ionic-ios-add-circle-outline.9f6b897e.svg";